module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": "Informações Fiscais"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "NCM"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ncm),
      expression: "product.ncm"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('########'),
      expression: "'########'"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "99999999"
    },
    domProps: {
      "value": (_vm.product.ncm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "ncm", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-4@md",
    attrs: {
      "label": "Origem do Produto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.originType),
      expression: "product.originType"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "originType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'manufacturer'
    }
  }, [_vm._v("Fabricação própria")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'reseller'
    }
  }, [_vm._v("Importacao Direta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'imported'
    }
  }, [_vm._v("Importado adquirido no Brasil")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-4@md",
    attrs: {
      "label": "Código Detalhe Origem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.originDetail),
      expression: "product.originDetail"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###'),
      expression: "'###'"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "99"
    },
    domProps: {
      "value": (_vm.product.originDetail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "originDetail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Consultar o ID no seu painel do Marketplace Mercado Livre")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Código Situação Simples Nacional"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.csosn),
      expression: "product.csosn"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####'),
      expression: "'####'"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "9999"
    },
    domProps: {
      "value": (_vm.product.csosn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "csosn", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("deve ser fornecido apenas para Regime Simples Nacional, para Regime Normal deixar em branco")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Código Grupo de Regra Tributária"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.taxRuleId),
      expression: "product.taxRuleId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###'),
      expression: "'###'"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "99"
    },
    domProps: {
      "value": (_vm.product.taxRuleId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "taxRuleId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Consultar o ID no seu painel do Marketplace Mercado Livre (penas para Regime Normal, para Simples Nacional deixar em branco)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Código Especificador da Substituição Tributária"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.cest),
      expression: "product.cest"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#######'),
      expression: "'#######'"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "9999999"
    },
    domProps: {
      "value": (_vm.product.cest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "cest", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Ficha de Conteúdo Importação"
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('########-####-####-####-############'),
      expression: "'########-####-####-####-############'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.fci),
      expression: "product.fci"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "99999999-9999-9999-9999-999999999999"
    },
    domProps: {
      "value": (_vm.product.fci)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "fci", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Código Exceção tributária"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.exTipi),
      expression: "product.exTipi"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "99"
    },
    domProps: {
      "value": (_vm.product.exTipi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "exTipi", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-3@md",
    attrs: {
      "label": "Código Anvisa"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.medAnvisaCode),
      expression: "product.medAnvisaCode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "ISENTO"
    },
    domProps: {
      "value": (_vm.product.medAnvisaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "medAnvisaCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Para isenção, preencha apenas o campo ao lado, informando o motivo")])]), _vm._v(" "), _c('form-group', {
    staticClass: "l-col-9@md",
    attrs: {
      "label": "Motivo Isenção",
      "required": _vm.product.medAnvisaCode === ''
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.medExemptionReason),
      expression: "product.medExemptionReason"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Motivo isenção"
    },
    domProps: {
      "value": (_vm.product.medExemptionReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "medExemptionReason", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Peso Líquido"
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('####.###'),
      expression: "'####.###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.netWeight),
      expression: "product.netWeight"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "999.999"
    },
    domProps: {
      "value": (_vm.product.netWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "netWeight", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Peso Bruto"
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('####.###'),
      expression: "'####.###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.product.grossWeight),
      expression: "product.grossWeight"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "999.999"
    },
    domProps: {
      "value": (_vm.product.grossWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "grossWeight", $event.target.value)
      }
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e789b78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/general/FiscalAttributes.vue
// module id = 3207
// module chunks = 0